import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import { productListStyles } from "@insite/content-library/Widgets/OrderConfirmation/OrderConfirmationProductList";

import { css } from "styled-components";

productListStyles.orderLinesList = mergeToNew(productListStyles.orderLinesList, {
    cardExpanded: {
        productImage: {
            img: {
                css: css`
                    height: auto;
                    width: auto;
                    max-height: 133px;
                    max-width: 100%;
                `,
            },
        },
        price: {
            priceWrapper: {
                css: css`
                    margin-top: 0;
                `,
            },
            price: {
                priceText: {
                    size: 16,
                },
            },
        },
    },
    header: {
        checkboxGroup: {
            css: css`
                display: none;
            `,
        },
    },
});
